// extracted by mini-css-extract-plugin
export default {"HistorySingle":"ti_tj","HistorySingle_drawer":"ti_tk","HistorySingleResponsive":"ti_tl","centered":"ti_te"};